<div class="container">
  <div class="filter-container">
    <app-global-reporting-filters
      showModelOnly="false"
      [isSearchFilter]="showSearch"
      [exportColumns]="exportColumns"
      [exportKey]="exportKey"
      (isFilterValueChange)="toggleFilter($event)"
      (onGlobalFilterChange)="onSearch($event)"
      (onReloadGrid)="onReloadGrid()"
      [gridUrl]="gridUrl"
    ></app-global-reporting-filters>
  </div>
  <div class="grid-container">
    <app-reporting-grid-wrapper
      [page]="'sector'"
      [columns]="columns"
      [gridUrl]="gridUrl"
      [showGridFilters]="showGridFilters"
      [sortKey]="sortKey"
      [(globalSearchVal)]="globalSearchVal"
      *ngIf="isDataSet"
    ></app-reporting-grid-wrapper>
  </div>
</div>
